import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import OpenInNewOutlinedIcon from '@material-ui/icons/OpenInNewOutlined';

import RequestAppliedOffersSkeleton from '../skeleton/request-applied-offers-skeleton';
import { renderAttachment } from '../../../../helpers/attachment-helper';
import { checkTokenExpirationMiddleware } from '../../../../middlewares/users-auth.middleware';
const useRowStyles = makeStyles({
    root: {
        '& > *': {
            borderBottom: 'unset',
        },
    },
    wideTd: {
        minWidth: `125px`,
        maxWidth: `300px`
    }
});

const FlightAppliedOffers = ({ reloadOffers, reservationReqId }) => {
    const [flightOffers, setFlightOffers] = useState(null);
    const [user] = useState(checkTokenExpirationMiddleware());
    const [loading, setLoading] = useState(true);
    const [, setError] = useState(null);

    let headers = {
        "Authorization": `Bearer ${user.Token}`
    };
    useEffect(() => {
        setLoading(true);
        axios.get(`/api/flightoffer?reservationReqId=${reservationReqId}`, { headers: headers })
            .then(res => {
                setFlightOffers(res.data);
                setTimeout(() => setLoading(false), 750);
            })
            .catch(err => { setError({ error: "Error Loading page" }); });
    }, [reloadOffers]);

    return (
        loading ?
            <RequestAppliedOffersSkeleton />
            :
            flightOffers.length > 0 ?
                <TableContainer>
                    <Table aria-label="collapsible table">
                        <TableHead>
                            <TableRow>
                                <TableCell />
                                <TableCell>Offer Headline</TableCell>
                                <TableCell>More Details</TableCell>
                                <TableCell>Flight Type</TableCell>
                                <TableCell>Create Date</TableCell>
                                <TableCell>Adults(Price/Adult)</TableCell>
                                <TableCell>Children(Price/Child)</TableCell>
                                <TableCell>Infants(Price/Infant)</TableCell>
                                <TableCell>Payment Policy</TableCell>
                                <TableCell>Issuance Time Limit</TableCell>
                                <TableCell>Cancellation Policy</TableCell>
                                <TableCell>Changes Policy</TableCell>
                                <TableCell>Attachment</TableCell>
                                <TableCell>Created By</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                flightOffers ?
                                    flightOffers.map((flightOffer, index) => (
                                        <Row key={index} row={flightOffer} />
                                    )) :
                                    null
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
                :
                <>
                    You haven't applied any offers for this request.
                </>
    );
}

const Row = ({ row }) => {
    const [open, setOpen] = React.useState(false);
    const classes = useRowStyles();
    return (
        <React.Fragment>
            <TableRow className={classes.root}>
                <TableCell>
                    <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                </TableCell>
                <TableCell className={classes.wideTd}>{row.offerHeadline}</TableCell>
                <TableCell>
                    <Link to={`/offer/flight/${row.id}`}><OpenInNewOutlinedIcon /></Link>
                </TableCell>
                <TableCell component="th" scope="row" className={classes.wideTd}>
                    {row.flightTypeName}
                </TableCell>
                <TableCell className={classes.wideTd}>{row.createDate.replace('T', ' ').substring(0, 16)}</TableCell>
                <TableCell>{row.adultsNumber}({row.adultPrice})</TableCell>
                <TableCell>
                    {row.childrenNumber === null ? '-' : `${row.childrenNumber}(${row.childPrice})`}
                </TableCell>
                <TableCell>
                    {row.infantsNumber === null ? '-' : `${row.infantsNumber}(${row.infantPrice})`}
                </TableCell>
                <TableCell className={`${classes.wideTd} no-wrap`}>{row.paymentPolicy}</TableCell>
                <TableCell className={`${classes.wideTd} no-wrap`}>{row.issuanceTimeLimit}</TableCell>
                <TableCell className={`${classes.wideTd} no-wrap`}>{row.cancellationPolicy}</TableCell>
                <TableCell className={`${classes.wideTd} no-wrap`}>{row.changesPolicy}</TableCell>
                <TableCell>{renderAttachment(row.attachment)}</TableCell>
                <TableCell className={`${classes.wideTd} no-wrap`}>{row.createdBy}</TableCell>
            </TableRow>
            <TableRow>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={14}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box margin={1}>
                            <Typography variant="h6" gutterBottom component="div">
                                Flights
                            </Typography>
                            <Table size="small" aria-label="flights">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>From</TableCell>
                                        <TableCell>To</TableCell>
                                        <TableCell>Departure Date</TableCell>
                                        <TableCell>Return Date</TableCell>
                                        <TableCell>Airline</TableCell>
                                        <TableCell>Flight Cabin</TableCell>
                                        <TableCell>Direct/Indeirect</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {row.reservationSupplierFlightOfferDetailResources.map((flightRow, index) => (
                                        <TableRow key={index}>
                                            <TableCell component="th" scope="row">
                                                {flightRow.fromCityName}
                                            </TableCell>
                                            <TableCell>{flightRow.toCityName}</TableCell>
                                            <TableCell>{flightRow.departureDate.substring(0, 10)}</TableCell>
                                            <TableCell>{flightRow.returnDate ? flightRow.returnDate.substring(0, 10) : '-'}</TableCell>
                                            <TableCell>{flightRow.airlineName}</TableCell>
                                            <TableCell>{flightRow.flightCabinType1}</TableCell>
                                            <TableCell>{flightRow.isDirectFlight ? 'Direct' : 'Indirect'}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </React.Fragment>
    );
}


export default FlightAppliedOffers;